const QUESTIONS = [
  {
    q: "Does it read all of my email?",
    a: "The worker downloads new mail, but only emails that look financial (receipt/invoice/payment wording, or a PDF/image attachment) are sent to the AI. Everything else is marked as skipped and never parsed.",
  },
  {
    q: "Which inboxes are supported?",
    a: "Gmail and Google Workspace (OAuth), Outlook and Microsoft 365 (OAuth), and any IMAP server, such as Fastmail, iCloud or Yahoo, using an app password. You can connect several mailboxes.",
  },
  {
    q: "How are receipts parsed?",
    a: "Entirely by AI. The AI model reads the email text, PDFs and images together and returns structured fields. There are no per-sender templates to maintain, so new vendors work on day one.",
  },
  {
    q: "What if the AI gets something wrong?",
    a: "Edit any field on the receipt page, reparse it, or click “Report incorrect parsing” so an administrator can review it.",
  },
  {
    q: "How does the QuickBooks connection work?",
    a: "Connect your QuickBooks Online company and pick default accounts. Paid receipts become Purchases, unpaid bills become Bills, and income becomes Sales Receipts, each with the source PDF attached. Pushes are idempotent, so nothing is posted twice.",
  },
  {
    q: "Are my credentials safe?",
    a: "Gmail and Outlook use OAuth, so your password is never shared. OAuth tokens, IMAP passwords and QuickBooks tokens are all encrypted at rest.",
  },
];

export default function FAQ() {
  return (
    <div className="faq-page">
      <div className="section-eyebrow">FAQ</div>
      <h1 className="section-heading">Frequently asked questions</h1>
      <p className="section-lead" style={{ marginBottom: 0 }}>
        Can't find an answer? Contact your Set &amp; Ledger administrator.
      </p>
      <div style={{ marginTop: 24 }}>
        {QUESTIONS.map((item) => (
          <div key={item.q} className="faq-item">
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
